export default function(params) {
  const self = this;

  self.id = params['id'];
  self.src = params['src'];
  self.$node = $(params['node']);
  self.waveFormContainer = params['node'].querySelector('.js-ws-audio-player-waveform');
  self.playing = ko.observable(false);
  self.muted = ko.observable(false);

  self.play = function(){
    self.wavesurfer.play();
    self.playing(true);
  };

  self.pause = function(){
    if (self.playing()) {
      self.wavesurfer.pause();
      self.playing(false);
    }
  };

  self.mute = function(){
    self.wavesurfer.setVolume(0);
    self.muted(true);
  };

  self.unmute = function(){
    self.wavesurfer.setVolume(1);
    self.muted(false);
  };

  self.init = function() {
    self.wavesurfer = WaveSurfer.create({
      container: self.waveFormContainer,
      waveColor: '#37575b',
      progressColor: '#2f3738'
    });
    self.wavesurfer.load(params['src']);
  };

  self.init();

  return self;
}

